import { getLocale, type Locale } from './locale.ts';
import { t } from './t.ts';

/**
 * The tag `Intl` formats with. `undefined` for English, which is what the
 * `toLocale*String(undefined, …)` calls this replaced passed: the English
 * catalog names no region, so an en-GB reader keeps "27 Sept" rather than
 * being handed America's "Sep 27".
 */
function intlTag(locale: Locale): string | undefined {
  return locale === 'en' || locale === 'qps' ? undefined : locale;
}

export function formatDate(date: Date, options?: Intl.DateTimeFormatOptions): string {
  return date.toLocaleDateString(intlTag(getLocale()), options);
}

export function formatDateTime(date: Date): string {
  return date.toLocaleString(intlTag(getLocale()));
}

/** A month label for a narrow column: "Sep", or Vietnamese's "T9". */
export function formatMonthShort(date: Date): string {
  return t('date-month-short', { name: formatDate(date, { month: 'short' }), month: date.getMonth() + 1 });
}

/** A day and month for a chart axis: "1 Oct", or Vietnamese's "1/10". */
export function formatDayMonth(date: Date): string {
  return t('date-day-month', {
    name: formatDate(date, { day: 'numeric', month: 'short' }),
    day: date.getDate(),
    month: date.getMonth() + 1,
  });
}
